// @flow
import React from 'react';
import {
    View, useWindowDimensions, Pressable,
} from 'react-native';
import { useIntl } from 'react-intl';
import { useNavigation } from '@react-navigation/native';
import { navigateWithoutHistory } from 'src/navigation/Stack';
import { HOME_SCREEN } from 'src/navigation/constants';
import Text from '../../components/CustomText/CustomText';
import DeleteIcon from '../../Icons/DeleteIcon';
import SaveIcon from '../../Icons/SaveIcon';
import DisabledDeleteIcon from '../../Icons/DisabledDeleteIcon';
import DisabledSaveIcon from '../../Icons/DisabledSaveIcon';
import Footer from '../../components/Footer/Footer';
import { wrapperStyles } from '../defaultPageStyles';

type Props = {
    children: any,
    onSaveHandler: Function,
    onDeleteHandler: Function,
    editing: Boolean,
    hasChange: Boolean,
    currentProfile: Object | null,
    allowSave: Boolean,
}

const ProfileWrapper = (props: Props) => {
    const navigation = useNavigation();
    const onHomeButtonClickHandler = () => {
        navigateWithoutHistory(navigation, HOME_SCREEN);
    };
    const { width } = useWindowDimensions();
    const {
        children, onDeleteHandler, onSaveHandler, editing, hasChange, currentProfile,
        allowSave,
    } = props;

    const { formatMessage } = useIntl();
    const EditDeleteButtons = () => {
        if (currentProfile?.parent) {
            return (
                <View style={width > 600 ? wrapperStyles.row_direction : wrapperStyles.col_direction}>
                    {(hasChange && allowSave) ? (
                        <Pressable
                            onPress={onSaveHandler}
                        >
                            <View style={wrapperStyles.icon_wrapper}>
                                <SaveIcon />
                                <Text style={wrapperStyles.home_button_text}>
                                    {formatMessage(
                                        { id: 'save_button', defaultMessage: 'Save' },
                                    )}
                                </Text>
                            </View>
                        </Pressable>
                    ) : (
                        <View style={wrapperStyles.icon_wrapper}>
                            <DisabledSaveIcon />
                            <Text style={wrapperStyles.home_button_text_disabled}>
                                {formatMessage(
                                    { id: 'save_button', defaultMessage: 'Save' },
                                )}
                            </Text>
                        </View>
                    )}
                </View>
            );
        }
        return (
            <View style={width > 600 ? wrapperStyles.row_direction : wrapperStyles.col_direction}>
                {(hasChange && allowSave) ? (
                    <Pressable
                        onPress={onSaveHandler}
                    >
                        <View style={wrapperStyles.icon_wrapper}>
                            <SaveIcon />
                            <Text style={wrapperStyles.home_button_text}>
                                {formatMessage(
                                    { id: 'save_button', defaultMessage: 'Save' },
                                )}
                            </Text>
                        </View>
                    </Pressable>
                ) : (
                    <View style={wrapperStyles.icon_wrapper}>
                        <DisabledSaveIcon />
                        <Text style={wrapperStyles.home_button_text_disabled}>
                            {formatMessage(
                                { id: 'save_button', defaultMessage: 'Save' },
                            )}
                        </Text>
                    </View>
                )}

                {editing ? (
                    <Pressable
                        onPress={onDeleteHandler}
                    >
                        <View style={wrapperStyles.icon_wrapper}>
                            <DeleteIcon />
                            <Text style={wrapperStyles.home_button_text}>
                                {formatMessage(
                                    { id: 'delete', defaultMessage: 'Delete' },
                                )}
                            </Text>
                        </View>
                    </Pressable>
                ) : (
                    <View style={wrapperStyles.icon_wrapper}>
                        <DisabledDeleteIcon />
                        <Text style={wrapperStyles.home_button_text_disabled}>
                            {formatMessage(
                                { id: 'delete', defaultMessage: 'Delete' },
                            )}
                        </Text>
                    </View>
                )}
            </View>
        );
    };

    return (
        <>
            <View style={width > 600 ? wrapperStyles.main_wrapper : wrapperStyles.main_wrapper_phone}>
                <View style={width > 600 ? wrapperStyles.buttons_wrapper : wrapperStyles.buttons_wrapper_phone}>
                    <Pressable
                        onPress={onHomeButtonClickHandler}
                    >
                        <Text style={wrapperStyles.home_button_text}>
                            {formatMessage({
                                id: 'home-button',
                                defaultMessage: 'Home',
                            })}
                        </Text>
                    </Pressable>
                    <EditDeleteButtons />
                </View>
                {children}
                <View style={width > 600 ? wrapperStyles.buttons_wrapper : wrapperStyles.buttons_wrapper_phone}>
                    <Pressable
                        onPress={onHomeButtonClickHandler}
                    >
                        <Text style={wrapperStyles.home_button_text}>
                            {formatMessage({
                                id: 'home-button',
                                defaultMessage: 'Home',
                            })}
                        </Text>
                    </Pressable>
                    <EditDeleteButtons />
                </View>
            </View>
            <Footer />
        </>
    );
};

export default ProfileWrapper;
